import { BrowserRouter, Routes, Route, HashRouter } from "react-router-dom";
import useApp, { AppContextProvider } from "./context/AppContext";
import Login from "./pages/Login";
import CasdastrarSenha from "./pages/CadastrarSenha";
import ModalMsg from "./component/ModalMsg";
import CodigoAtivacao from "./pages/CodigoAtivacao";

import "./styles/main.scss";
import "./styles/modal.scss";
import "./styles/util.scss";
import "./styles/modelo_fatura.scss";
import "./styles/table-main.scss";
import "./styles/table-util.scss";
import ListaDocumentos from "./pages/ListaDocumentos";
import InserirDocumento from "./pages/InserirDocumento";
import InserirItensDocumento from "./pages/InserirItensDocumentos";
import Spinner from "./component/Spinner";
import DadosAdicionaisDoc from "./pages/DadosAdicionaisDoc";
import DadosCadastrais from "./pages/DadosCadastrais";
import ImprimeFatura from "./pages/ImprimeFatura";
import Resumo from "./pages/Resumo";
import {setEnterAsTab} from "./utils/functions"
import { IoMdHelp } from "react-icons/io";
import HelpIcon from "./component/HelpIcon";

function App() {
  setEnterAsTab()
  return (
    <AppContextProvider>
      <div className="App">
        <ModalMsg />
        <Rotas />
      </div>
    </AppContextProvider>
  );
}

const Rotas = () => {
  const {loading} = useApp();
  return (<>
    {loading && <Spinner />}
    <BrowserRouter basename={"fornecedores"}>
    <HelpIcon/>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/cadastrarSenha" element={<CasdastrarSenha />} />
        <Route path="/codigoAtivacao" element={<CodigoAtivacao />} />
        <Route path="/listarDocumentos" element={<ListaDocumentos />} />
        <Route path="/inserirDocumento" element={<InserirDocumento />} />
        <Route path="/inserirItensDocumento" element={<InserirItensDocumento />} />
        <Route path="/dadosAdicionais" element={<DadosAdicionaisDoc />} />
        <Route path="/dadosCadastrais" element={<DadosCadastrais />} />
        <Route path="/imprimeFatura" element={<ImprimeFatura />} />
        <Route path="/resumoNota" element={<Resumo />} />
      </Routes>
    </BrowserRouter>
    </>
  );
};

export default App;
